import React, { useEffect, useState, useContext } from 'react'
import { useRouter } from 'next/router'
import getConfig from 'next/config'
import Context from '../context'
import { useAuthAPI } from '../hooks/api.hooks'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Keyboard, Pagination, FreeMode, Navigation } from 'swiper/modules'

import 'swiper/css'
import 'swiper/css/free-mode'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import 'swiper/css/scrollbar'
import 'swiper/css/keyboard'

import MiniProductCard from './MiniProductCard'
const { publicRuntimeConfig } = getConfig()

const Widget = ({ slug, type, data }) => {
  const router = useRouter()
  const { state } = useContext(Context)
  const [widgetData, setWidgetData] = useState<any>({ ...data })
  const authAPICall = useAuthAPI()
  const swiperConfig = {
    modules: [FreeMode, Pagination, Navigation, Keyboard],
    freeMode: true,
    pagination: { clickable: true },
    navigation: false,
    spaceBetween: 16,
    keyboard: true,
    watchOverflow: true
  }
  const MORE_RESULTS = 'more-results'

  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.br_related_rid = data.br_related_rid
    }
  }, [])

  useEffect(() => {
    authAPICall(
      'productinfo',
      'recommended',
      'GET',
      {
        slug,
        type,
        store: state.cart.store?.storenumber || publicRuntimeConfig.DEFAULT_STORE,
        popkey: publicRuntimeConfig.POP_KEY
      },
      {},
      {
        deviceid: state.deviceId || ''
      }
    ).then(data => setWidgetData(data.body.data))
  }, [state.cart.store?.storenumber])

  return (
    <div className="widget">
      {!!widgetData['related-item']?.length && (
        <>
          <p className="widget__heading">related items</p>
          <div className="widget__related">
            <div className="widget__related-list">
              {widgetData['related-item'].map((term) => (
                <button className='widget-item' onClick={() => router.push(`${term.url}`)} key={term.url}>
                  {term.anchor}
                </button>
              ))}
            </div>
          </div>
        </>
      )}

      {!!widgetData['related-category']?.length && (
        <>
          <p className="widget__heading">related categories</p>
          <div className="widget__related">
            <div className="widget__related-list">
              {widgetData['related-category'].map((term) => (
                <button className='widget-category' onClick={() => router.push(`${term.url}`)} key={term.url}>
                  {term.anchor}
                </button>
              ))}
            </div>
          </div>
        </>
      )}

      {!!widgetData[MORE_RESULTS]?.length && (
        <>
          <p className="widget__heading">related products</p>
          <section className='swiper__section content-carousel'>
            <Swiper {...swiperConfig} slidesPerView={'auto'}>
              {widgetData[MORE_RESULTS].map(product => (
                <SwiperSlide key={product.slug}>
                  <MiniProductCard data={{ ...product, image: product.image_urls }} key={product.slug} />
                </SwiperSlide>
              ))}
            </Swiper>
          </section>
          <div className="widget__products-desktop">
            {widgetData[MORE_RESULTS].map((product) => (
              <MiniProductCard data={{ ...product, image: product.image_urls }} key={product.slug} />
            ))}
          </div>
        </>
      )}
    </div>
  )
}

export default Widget
